/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const CirclePoundSterling = [
  ["circle", { cx: "12", cy: "12", r: "10" }],
  ["path", { d: "M10 16V9.5a1 1 0 0 1 5 0" }],
  ["path", { d: "M8 12h4" }],
  ["path", { d: "M8 16h7" }]
];

export { CirclePoundSterling as default };
//# sourceMappingURL=circle-pound-sterling.js.map
